import { api } from "./api";
import { getGuestId } from "../utils/guest";
import { getUserFromToken } from "../services/User";
export const createPaymentLink = async (orderId) => {
  try {
    const user = getUserFromToken();
    const payload = {
      orderId,
      returnUrl: `${window.location.origin}/checkout`,
      cancelUrl: `${window.location.origin}/order-success`,
      guestId: !user ? getGuestId() : null
    };

    const response = await api.post("/QR/create-payment-link", payload);

    return response.data;
  } catch (error) {
    console.error("❌ Error in createPaymentLink:", error);
    throw error;
  }
};
export const getPaymentInfo = async (orderId) => {
  try {
    const response = await api.get(`/QR/info/${orderId}`);
    return response.data;
  } catch (error) {
    console.error("❌ Error in getPaymentInfo:", error);
    throw error;
  }
};